module.exports = __webpack_public_path__ + "static/media/bomb.9f7af855.svg";